import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderSlot as _renderSlot, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "scroll-left" }
const _hoisted_2 = { class: "inner" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "arrow icon-next" }, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "scroll-rail" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["scroll", [_ctx.styleBar]]),
    ref: "scroll"
  }, [
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["scroll-up", { reverse: _ctx.isReverseScroll }]),
      ref: "scrollUp"
    }, [
      _createElementVNode("div", {
        class: "left-wrapper",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollTop && _ctx.scrollTop(...args))),
        style: _normalizeStyle(_ctx.leftScrollStyle)
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                (!_ctx.isReverseScroll)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Вверх"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ])
      ], 4),
      _createElementVNode("div", {
        class: "scroll-right",
        style: _normalizeStyle(_ctx.rightScrollStyle),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollTop && _ctx.scrollTop(...args)))
      }, null, 4)
    ], 2), [
      [_vShow, _ctx.isScrollUp && _ctx.isShowScrollUp]
    ]),
    _createElementVNode("div", {
      class: "scroll-content",
      ref: "content",
      style: _normalizeStyle([_ctx.scrollStyle, { right: `-${_ctx.scrollWidth}px` }])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 4),
    (_ctx.displayBar && _ctx.scrollWidth != 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["scroll-bar", { slide: _ctx.hideScroll }])
        }, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "slider",
            onMousedown: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.mouseDownBar && _ctx.mouseDownBar(...args)), ["left"])),
            style: _normalizeStyle({ top: _ctx.top + 'px', height: _ctx.height + 'px' })
          }, null, 36)
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}